import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Overline } from "@/components/Reveal";

const FAQS = [
  {
    q: "How do I schedule a delivery?",
    a: "Scheduling a delivery with us is simple: 1 — Log into your HLM account to view the order page. 2 — Add your order details: pickup and delivery facilities, specimen category, and delivery window. 3 — Review your order and click the SUBMIT ORDER button. Our dispatch engine immediately routes the closest vetted Sprinter van and sends live GPS tracking.",
  },
  {
    q: "What geographical area does HLM Courier service?",
    a: "HLM Courier operates directly throughout the DMV region — Washington DC, Maryland, and Virginia — with headquarters at 23710 Schooler Plz, Ashburn, VA 20148.",
  },
  {
    q: "Are your drivers trained for hazardous and biohazard transport?",
    a: "Yes. All drivers maintain active certifications in OSHA 29 CFR 1910.1030 (Bloodborne Pathogen standards), TWIC security clearance, GDP practices, and chemotherapy/hazardous drug spill containment.",
  },
  {
    q: "Can we integrate HLM Courier into our hospital or lab software?",
    a: "Yes. We provide robust REST APIs and webhooks for instant order generation, automated manifests, and digital signature capture directly inside your LIMS/EHR.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-white py-24 lg:py-32 scroll-mt-20">
    <div className="mx-auto max-w-3xl px-5 sm:px-8">
      <Reveal className="text-center">
        <Overline>Got More Questions?</Overline>
        <h2 className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 leading-tight">
          Frequently asked questions.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} data-testid={`faq-item-${i}`}
                           className="rounded-2xl border border-slate-200/80 bg-[#F8FAFC] px-6 data-[state=open]:bg-white data-[state=open]:shadow-lg data-[state=open]:border-blue-500/40 transition-all duration-300">
              <AccordionTrigger data-testid={`faq-trigger-${i}`}
                                className="text-left font-display text-base sm:text-lg font-bold text-slate-900 hover:text-[#0047FF] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="text-sm sm:text-base leading-relaxed text-slate-600 pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
